import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DOCUMENT,
    ElementRef,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges
} from '@angular/core';
import { Renderer } from '@df/ng/renderer';
import { BlockScrollService } from '@df/ui/block-scroll.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'overlay',
    template: '',
    styleUrl: './overlay.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent implements OnChanges, OnDestroy {
    @Input({ required: true })
    visible!: BehaviorSubject<boolean> | boolean;

    /**
     * If scrolling should be blocked
     */
    @Input()
    blockScroll = true;

    /**
     * If is currently visible
     */
    private _visible = false;

    /**
     * Subscription
     */
    private subscription?: Subscription;

    /**
     * Deps
     */
    constructor(
        private renderer: Renderer,
        private elementRef: ElementRef,
        private blockScrollService: BlockScrollService,
        ref: ChangeDetectorRef,
        @Inject(DOCUMENT)
        protected documentRef: Document
    ) {
        ref.detach();
    }

    /**
     * Input changes listener
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['visible']) {
            if (typeof this.visible === 'boolean') {
                this.update(this.visible);
            } else if (this.visible) {
                this.subscription?.unsubscribe();

                this.subscription = this.visible.subscribe(value => this.update(value));
            } else {
                this.update(false);
            }
        }
        this.updateScrollBlock();
    }

    /**
     * Cleanup
     */
    ngOnDestroy() {
        this.subscription?.unsubscribe();
        this.blockScrollService.disable(this);
    }

    /**
     * Update visibility class
     */
    private update(_visible: boolean) {
        if (this._visible !== _visible) {
            this._visible = _visible;
            this.renderer.setClass(this.elementRef.nativeElement, '_visible', this._visible);
            this.updateScrollBlock();
        }
    }

    /**
     * Syncs status of scroll blocking
     */
    private updateScrollBlock() {
        const shouldBlock = this._visible && this.blockScroll;

        if (shouldBlock) {
            this.blockScrollService.enable(this);
        } else {
            this.releaseScroll();
        }
    }

    /**
     * Releases the scroll block
     */
    private releaseScroll() {
        this.blockScrollService.disable(this);
    }
}
